import React from "react";
import styled from "styled-components";
import withoutpayIcon from "../assets/icons-fleet/icon-shorttime-withoutpay.svg";
import SVGnumber from "./../components/SVGnumber";

import timesBlack from "./../assets/icons-main/times-black.png";
import mouseGrey from "./../assets/icons-main/mouse-grey.png";

const MotoconciergeSingleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 0 30px;
  justify-content: center;
  max-width: 1550px;
  padding: ${props => (!props.first ? "0 100px" : "0")};
  flex-direction: ${props =>
    !props.odd || props.first ? "row" : "row-reverse"};

  @media (max-width: 1200px) {
    padding: 0;
  }

  @media (max-width: 767.98px) {
    padding: 0 30px;
  }

  > div {
    width: 50%;
    @media (max-width: 767.98px) {
      width: 100%;
    }
  }

  img {
    width: 100%;
    align-self: flex-start;
    margin-top: 70px;
    max-width: 280px;
    margin-right: 180px;

    @media (max-width: 767.98px) {
      display: none;
      margin-right: 0;
    }
  }

  .svg-section {
    border-left: ${props =>
      props.odd ? "1px solid rgb(236, 238, 242)" : "none"};

    @media (max-width: 1200px) {
      padding: 0 30px;
    }

    @media (max-width: 767.98px) {
      padding: 0 60px 0 0;
      border-left: none;
    }

    .svg-wrapper {
      svg {
        display: block;
        margin-left: ${props => (props.odd ? "auto" : "0")};
        max-width: 356px;

        @media (max-width: 767.98px) {
          margin: 50px auto 20px;
          margin-left: 0;
        }
      }
    }
  }

  .desc-section {
    position: relative;

    border-left: ${props =>
      !props.odd ? "1px solid rgb(236, 238, 242)" : "none"};

    @media (max-width: 1200px) {
      padding: 0 30px;
    }

    @media (max-width: 767.98px) {
      padding: 0;
      border-left: none;
    }

    .mouse-line {
      height: 25px;
      width: auto;
      position: absolute;
      background: white;
      padding: 22px;
      box-sizing: content-box;
      top: -10px;
      margin: 0;
      left: ${props => (!props.odd ? "-30px" : "none")};
      right: ${props => (props.odd ? "-30px" : "none")};
    }

    .desc-wrapper {
      position: relative;
      max-width: ${props => (props.first ? "560px" : "440px")};
      padding-bottom: 165px;
      margin-left: ${props => (!props.odd ? "auto" : "none")};

      @media (max-width: 767.98px) {
        max-width: 100%;
        padding: 50px 0;
      }

      .times-black {
        position: absolute;
        top: 35px;
        right: 40px;
        width: 18px;
        z-index: 10;
        padding: 15px;
        margin: 0;
        cursor: pointer;
        z-index: 15;
        box-sizing: content-box;
      }

      .button-modal {
        display: inline-block;
        cursor: pointer;
        font-size: 15px;
        line-height: 15px;
        border-bottom: 1px solid #ff5000;
        font-weight: 700;
        font-family: "Roboto Mono";
      }

      .modal-wrapper {
        position: relative;
      }

      .modall {
        position: absolute;
        background: #ff5000;
        left: -150px;
        margin-top: 20px;
        padding: 65px;
        z-index: 1;

        @media (max-width: 767.98px) {
          left: 30px;
          right: 30px;
        }

        p {
          font-family: "Roboto Mono";
          font-size: 15px;
          line-height: 26px;
          color: #000;
          margin-bottom: 0;
        }
      }
    }
  }

  h5 {
    font-family: "marsextended-regular";
    font-size: 36px;
    text-transform: none;
    margin-bottom: 50px;
    max-width: ${props => (props.first ? "580px" : "100%")};
  }

  p {
    font-size: 18px;
    line-height: 26px;
    font-family: "Neue Haas Grotesk";
    color: #8f9092;
    margin-bottom: 35px;
    max-width: ${props => (props.first ? "450px" : "100%")};
    max-width: 440px;

    @media (max-width: 767.98px) {
      max-width: 100%;
    }
  }
`;

class MotoconciergeSingle extends React.Component {
  state = {
    open: false
  };

  openHideDesc = () => {
    this.setState({
      open: !this.state.open
    });
  };

  render() {
    const { idx, item, first, odd } = this.props;

    return (
      <MotoconciergeSingleWrapper first={first} odd={odd}>
        {first && <img src={withoutpayIcon} alt="Youtube logo white" />}
        {!first && (
          <div className="svg-section">
            <div className="svg-wrapper">
              <SVGnumber version={idx} />
            </div>
          </div>
        )}
        <div className="desc-section">
          {!first && <img className="mouse-line" src={mouseGrey} alt="" />}
          <div className="desc-wrapper">
            <h5>{item.title}</h5>
            <div dangerouslySetInnerHTML={{ __html: item.desc }} />
            {item.button && (
              <>
                <span className="button-modal" onClick={this.openHideDesc}>
                  {item.button.title}
                </span>
                {this.state.open &&
                  item.button.desc && (
                    <div className="modal-wrapper">
                      <span
                        className="modall"
                        dangerouslySetInnerHTML={{ __html: item.button.desc }}
                      />
                      <img
                        onClick={this.openHideDesc}
                        className="times-black"
                        src={timesBlack}
                        alt=""
                      />
                    </div>
                  )}
              </>
            )}
          </div>
        </div>
      </MotoconciergeSingleWrapper>
    );
  }
}

MotoconciergeSingle.propTypes = {
  //
};

MotoconciergeSingle.defaultTypes = {
  //
};

export default MotoconciergeSingle;
